/** Estado de filtros/paginação da listagem de Cidades. */
export interface CityFilters {
  /** Texto de busca aplicado (client-side, por código ou nome). */
  readonly search: string;
  /** Página atual (1-indexed) da paginação client-side. */
  readonly page: number;
}

/** Estado inicial (sem busca, primeira página). */
export const INITIAL_CITY_FILTERS: CityFilters = {
  search: '',
  page: 1,
};
